import { useEffect, useReducer, useState } from 'react';
export const useTabs = ({ initialSelectedTab = 0, panelContentRef, }) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(initialSelectedTab);
    // Due to conflicts in render timing, it is necessary to manually force
    // an update so tab contents get focused when appropriate.
    const [reducerValue, forceUpdate] = useReducer(x => x + 1, 0);
    useEffect(() => {
        var _a, _b;
        // Greater than 0 because we don't want to run this logic when mounting
        if (reducerValue > 0) {
            ;
            (_b = (_a = panelContentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[tabindex="-1"]')) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [reducerValue]);
    const handleTabSelection = (index, focusPanelContent = true) => {
        setSelectedIndex(index);
        if (focusPanelContent) {
            setActiveIndex(null);
            // Force a rerender in order to fix an issue with render timing and focusing panel content
            forceUpdate();
        }
        else {
            setActiveIndex(index);
        }
    };
    return {
        activeTab: activeIndex,
        setActiveTab: setActiveIndex,
        dropdownOpen: open,
        setDropdownOpen: setOpen,
        selectedTab: selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0,
        onSelectedTabChange: handleTabSelection,
    };
};
//# sourceMappingURL=useTabs.js.map